    /*
     * Trigger Animations on Viewport just give class action-animationstyle-timeout to element
     */
    
(function( $ ) {
    
    var hamburgerAnimation = function() {
        
        $('#togglerbutton').click(function(){
            if ( !$(this).data("collapse") ) {
                $(this).data("collapse", true);
                $('#togglerbutton').addClass('is-active');
            } else {
                $(this).data("collapse", false);
                $('#togglerbutton').removeClass('is-active');
            }
        });

    };

hamburgerAnimation();

}(jQuery));


